import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    tasksList: [],
    taskById: [],
    taskOfRooms: [],
    allTasks:[]
  },
  getters: {
    getTasksList: (state) => state.tasksList,
    getTaskById: (state) => state.taskById,
    getTaskOfRooms: (state) => state.taskOfRooms,
    getAllTasks: (state) => state.allTasks
  },
  actions: {
    async getTasksList({ commit }, obj) {
      let url = "Tasks/GetAllTask";
      if (obj) {
        if (obj.page && obj.page_size) {
          url += `?pageNo=${obj.page}&pageSize=${obj.page_size}`;
        }
        if (obj.order_type && obj.order_field) {
          url += `&sortDirection=${obj.order_type}&sortColumn=${obj.order_field}`;
        }
        if (obj.search) {
          url += `&searchTerm=${obj.search}`;
        }
        if (obj.searchWithoutPagination) {
          url += `?searchTerm=${obj.searchWithoutPagination}`;
        }
      }
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setTasksList", response.data.data);
      }
    },
    async createTask({ commit }, payload) {
      const response = await makeApiCallWithImages(
        "Tasks/CreateTask",
        "POST",
        payload
      );
      return response;
    },
    async deleteTask({ commit }, id) {
      const response = await makeApiCall(`Tasks/DeleteTask?id=${id}`, "DELETE");
      return response;
    },
    async getTaskById({ commit }, id) {
      const response = await makeApiCall(`Tasks/GetTaskById?id=${id}`);
      if (!response.error) {
        commit("setTaskById", response.data.data[0]);
      }
    },
    async updateTask({ commit }, payload) {
      const response = await makeApiCall("Tasks/UpdateTask", "PUT", payload);
      return response;
    },
    async createTaskTemplate({ commit }, payload) {
      const response = await makeApiCall(
        "AssignedTemplate/CreateTask",
        "POST",
        payload
      );
      return response;
    },
    async getTaskOfRooms({ commit }, obj) {
      const response = await makeApiCall(
        `AssignedTemplate/GetTaskOfRooms?id=${obj.id}&&roomId=${obj.roomId}`
      );
      if (!response.error) {
        commit("setTaskOfRooms", response.data.data);
      }
    },
    async getAllTasks({commit},payload){
      const url = `assignTemplateService/getAllTasks`
      const response = await makeApiCall(url,'POST',payload);
      if(!response.error){
        commit('setAllTasks',response.data.data)
        
      }
    }
  },
  mutations: {
    setTasksList: (state, payload) => (state.tasksList = payload),
    setTaskById: (state, payload) => (state.taskById = payload),
    setTaskOfRooms: (state, payload) => (state.taskOfRooms = payload),
    setAllTasks: (state,payload) => state.allTasks = payload
  },
};
